import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { logoutTenantRegistry } from '@/api/auth-client';
import { clearHttpSession } from '@/api/http-session';
import { useRouter } from 'next/navigation';
type LogoutContextType = {
  logout: () => void;
};
export const LogoutContext = createContext<LogoutContextType | null>(null);
export function Auth0LogoutProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    logout
  } = useAuth0();
  let t1;
  if ($[0] !== logout) {
    t1 = {
      logout: () => {
        clearHttpSession();
        logout();
      }
    };
    $[0] = logout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ctx = t1;
  let t2;
  if ($[2] !== children || $[3] !== ctx) {
    t2 = <LogoutContext.Provider value={ctx}>{children}</LogoutContext.Provider>;
    $[2] = children;
    $[3] = ctx;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function TenantLogoutProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const router = useRouter();
  const logout = useCallback(async () => {
    clearHttpSession();
    try {
      await logoutTenantRegistry();
    } catch (error) {
      console.error('logout failed', error);
    } finally {
      router.push('/login');
    }
  }, [router]);
  const ctx = useMemo(() => ({
    logout
  }), [logout]);
  return <LogoutContext.Provider value={ctx}>{children}</LogoutContext.Provider>;
}